import ReactInputMask from "react-input-mask";
import styled, { css } from "styled-components";

export const AuthModalInputMaskContainer = styled(ReactInputMask)``;

interface IAuthModalInputContainerProps {
  isInputRequired: boolean;
}
export const AuthModalInputContainer = styled.div<IAuthModalInputContainerProps>`
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;

  label {
    font: 500 0.813rem/1.016rem "Inter";
    color: ${({ theme }) => theme.authModal.primaryText};
    margin-bottom: 0.5rem;

    display: flex;
    gap: 0.125rem;

    ${({ isInputRequired }) =>
      isInputRequired &&
      css`
        ::after {
          content: "*";
          color: red;
        }
      `}
  }

  input,
  ${AuthModalInputMaskContainer} {
    border-radius: 4px;
    padding: 0.625rem 0.75rem;
    height: 2.25rem;

    transition: all 0.4s ease;

    outline: none;
    background: ${({ theme }) => theme.authModal.inputBackgroundColor};

    border: 1px solid ${({ theme }) => theme.authModal.borderColor};
    caret-color: ${({ theme }) => theme.authModal.secondaryText};

    &:-webkit-autofill {
      box-shadow: 0 0 0 50px ${({ theme }) => theme.colors.inputBackgroundColor}
        inset !important;
      -webkit-text-fill-color: ${({ theme }) => theme.colors.textColor};
      background: content-box;
    }

    :invalid {
      box-shadow: 0 0 2px 1px red;
    }

    :required {
      box-shadow: inherit;
    }

    :focus {
      box-shadow: 0 0 2px 1px ${({ theme }) => theme.authModal.secondaryText};
    }

    ::placeholder {
      opacity: 0.7;
      color: ${({ theme }) => theme.authModal.secondaryText} !important;
    }
  }

  [data-testid="auth-modal-password-input"] {
    padding-right: 2rem;
  }

  .eye-password {
    position: absolute;
    right: 12px;
    top: 34px;

    font-size: 18px;
    pointer-events: visible;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.textColor};
  }

  input,
  input::placeholder,
  .eyePassword,
  span.prefix svg {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;
